import { createAuthModule } from '@bcecloud/frontend';

const auth = createAuthModule({
  cookieName: 'myevents_token',
  defaultSignupRole: 'client',
  clientName: 'myevents',
});

export const {
  getToken,
  setToken,
  removeToken,
  getUser,
  isAuthenticated,
  isConfirmed,
  login,
  register,
  forgotPassword,
  resetPassword,
  sendConfirmationEmail,
  refreshToken,
  logout,
  createAuthAdapter,
  setupTokenRefresh,
} = auth;
